var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"onebyone-product-search"}},[_c(_vm.dynamicComponent,{tag:"component",attrs:{"keyword":_vm.keyword,"page":_vm.page}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }